import { render, staticRenderFns } from "./FaqAdd.vue?vue&type=template&id=58b740ee&"
import script from "./FaqAdd.vue?vue&type=script&lang=js&"
export * from "./FaqAdd.vue?vue&type=script&lang=js&"
import style0 from "./FaqAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports